"use client"
import {Button} from "@heroui/button"
import {Link} from "@heroui/link"
import React, {useState, useEffect, useRef, useMemo} from 'react'
import {Slider} from "@heroui/slider"
import {Kbd} from "@heroui/kbd"
import {DurationInput} from "@/components/Trim/DurationInput";
import {useMonitoring} from "@/components/monitoring";
import {isDev, once} from "@/components/DownloaderApp/utils";
import {OutlineInfo} from "@/components/icons";
import {Tooltip} from "@heroui/tooltip";
import {calculateThumbnail} from "@/components/Trim/test";
import {useMediaQuery} from "@uidotdev/usehooks";
//https://stream.kick.com/ivs/v1/196233775518/gb20mPcO74wk/2025/3/27/19/1/RIPKSmAwPkiV/media/thumbnails/thumbnail-sheet-0.webp

const thumbnailWidth = 180;
const thumbnailHeight = 101;

function Thumbnail({durrationSec, thumbnailUrl, fromSecs, toSecs}) {

    const [index, setIndex] = useState(null);
    useEffect(() => {
        const newIndex = document.querySelector('[aria-label="QQ"] [data-hover="true"]')?.getAttribute('index');
        if (!newIndex) return;
        setIndex(+newIndex)
    }, []);


    const details = useMemo(() => calculateThumbnail({
        durationInMs: durrationSec * 1000,
        playbackThumbnailUrl: thumbnailUrl,
        pointerPosition: index === 0 ? fromSecs : toSecs,
        thumbnailWidth,
        thumbnailHeight
    }), [durrationSec, thumbnailUrl, index, fromSecs, toSecs, thumbnailWidth, thumbnailHeight]);

    if (index === null) return;

    // console.log("details", details);

    return <img src={details.url}
                className={`bg-no-repeat border-white border-1 min-w-[${thumbnailWidth}px] h-[${thumbnailHeight}px]`}
                style={{objectFit: 'none', objectPosition: `${details.xOffset}px ${details.yOffset}px`}}
    />;

    // return <img src={thumbnailUrl.replaceAll('{{chunk_no}}', '0')}
    //             className={"bg-no-repeat  border-white border-1 min-w-[180px] h-[101px]"}
    //             style={{objectFit: 'none', objectPosition: calc(index === 0 ? fromSecs : toSecs)}}
    // />
}

function secondsToTime(totalSeconds: number): number {
    return Math.max(0, Math.floor(totalSeconds));
}


function calc(seconds) {
    const thumbnailSize = {width: 180, height: 101}
    const rowSize = 5;
    const colSize = 30;
    // const sheetSize = await getImageSize(url);
    // const rowSize = sheetSize.width / thumbnailSize.width;
    // const colSize = sheetSize.height / thumbnailSize.height;
    // console.log({rowSize, colSize, sheetSize, thumbnailSize})

    let id = Math.floor(seconds / 60);
    id = id % (50 * 5)

    const xOffset = (id) % (rowSize);
    const yOffset = Math.floor(id / rowSize);

    return `-${(xOffset) * thumbnailSize.width}px -${yOffset * thumbnailSize.height}px`;
}


export const Trim = ({trim, secTrim, masterPlaylistUrl, playlist, onTrimChanged, video}) => {
    const totalSegments = playlist.segments.length;
    const isLiveStream = video?.type === 'live';
    const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");


    const {track} = useMonitoring();

    // useEffect(() => {
    //     try {
    //         window.posthog?.startSessionRecording();
    //     } catch (err) {
    //     }
    //
    //     return () => {
    //         try {
    //             window.posthog?.stopSessionRecording();
    //         } catch (err) {
    //         }
    //     }
    // }, []);

    const [value, _setValue] = useState(trim && video?.type !== "live" ? trim : [0, totalSegments]);
    const [fromTime, setFromTime] = useState(0);
    const [toTime, setToTime] = useState(0);
    const [totalDurationSec] = useState(playlist.segments.reduce((acc, s) => {
        return acc + s.duration;
    }, 0));

    const trackTrimChanged = useMemo(() => once(([from, to]) => track('Video Trimmed', {from, to})), [track])

    function setValue([from, to]: any) {
        if (from === to) return
        // trackTrimChanged([from, to])
        _setValue([from, to])
    }

    const allSegmentsSelected = value[1] - value[0] === totalSegments;

    useEffect(() => {
        let duration;

        if (allSegmentsSelected) {
            duration = isLiveStream ? `live stream` : 'entire video'
        } else {
            duration = formatSecondsToDuration(formatValue(value[1]) - formatValue(value[0]))
        }
        onTrimChanged?.(value, [fromTime, toTime], duration)
    }, [value]);

    const [thumbnailUrl, setThumbnailUrl] = useState(null);

    const {parsedTimestampsMap, secondsList} = useMemo(() => {
        if (!playlist) return null

        const parsedTimestampsMap = playlist.segments.reduce((acc, segment, index) => {
            const a = acc.last + (+segment.duration.toFixed(2));
            return {
                ...acc,
                [index]: a,
                last: a,
            }
        }, {last: 0});

        delete parsedTimestampsMap.last
        // console.log({
        //     parsedTimestampsMap,
        //     secondsList: Object.values(parsedTimestampsMap)
        // })
        return {
            parsedTimestampsMap,
            secondsList: Object.values(parsedTimestampsMap)
        };
    }, [playlist]);

    useEffect(() => {
        if (!parsedTimestampsMap) return;

        if (secTrim) {
            const [fromSecs, toSecs] = secTrim
            const toValue = toSecs != null ? getFromValueByFromSecs(toSecs) : totalSegments
            const resolvedToValue = toValue > 0 ? toValue : totalSegments
            setFromTime(secondsToTime(fromSecs || 0))
            setToTime(secondsToTime(formatValue(resolvedToValue)))

            setValue([fromSecs ? getFromValueByFromSecs(fromSecs) : 0, resolvedToValue])
            return;
        }
        setFromTime(secondsToTime(formatValue(value[0])))
        setToTime(secondsToTime(formatValue(value[1])))
    }, [parsedTimestampsMap]);

    // useEffect(() => {
    //     setMaxDate(secondsToTime(parsedTimestampsMap[playlist.segments.length - 1]));
    //     _setToTime(secondsToTime(parsedTimestampsMap[playlist.segments.length - 1]))
    // }, [parsedTimestampsMap]);

    function formatValue(index: any) {
        if (index === 0) return 0;
        return parsedTimestampsMap[index - 1]
    }

    // "https://stream.kick.com/ivs/v1/196233775518/gb20mPcO74wk/2025/4/26/17/28/ybyr5XGndFEG/media/thumbnails/thumbnail-sheet-0.webp"

    const fromSecs = formatValue(value[0]);
    const toSecs = formatValue(value[1]);

    // thumbnailUrl = masterPlaylistUrl.split('hls')[0] + `thumbnails/thumbnail-sheet-${Math.floor(Math.floor(fromSecs / 60) / (5 * 50))}.webp`

    useEffect(() => {
        let thumbnailUrlTemplate = '';
        // return;
        // if (video.platform === 'twitch') {
        //     thumbnailUrlTemplate = masterPlaylistUrl.split('chunked')[0] + `storyboards/${video.twitchVodId}-low-{{chunk_no}}.jpg`
        //
        //     window.sendMessage("fetch-segment", thumbnailUrlTemplate.replaceAll('{{chunk_no}}', '0')).then(arrayBuffer => {
        //         const blob = new Blob([new Uint8Array(arrayBuffer)], {type: 'image/jpg'});
        //         const url = URL.createObjectURL(blob);
        //
        //         const img = new Image();
        //         console.log({url})
        //         setThumbnailUrl(url)
        //     })
        //
        // } else {
        //
        // }
        if (video.platform === 'kick') {
            thumbnailUrlTemplate = masterPlaylistUrl.split('hls')[0] + `thumbnails/thumbnail-sheet-{{chunk_no}}.webp`;
        }
        // console.log('@@@@',{ video, masterPlaylistUrl, thumbnailUrlTemplate})
        if (!thumbnailUrlTemplate) return;
        fetch(thumbnailUrlTemplate.replaceAll('{{chunk_no}}', '0'), {
            method: 'HEAD',
        }).then(res => res.status).then(status => {
            // console.log({status});
            if (status === 200) {
                setThumbnailUrl(thumbnailUrlTemplate)
            }
        }).catch(err => {
            console.error(err);
        })
    }, []);

    function getFromValueByFromSecs(fromSecs) {
        const foundSegmentIndex = secondsList.findIndex(secStamp => secStamp > fromSecs)
        // console.log({
        //     foundSegmentIndex,
        //     foundSegment: secondsList[foundSegmentIndex],
        // })
        return foundSegmentIndex
    }

    return (
        <div>
            <Slider
                aria-label="QQ"
                className="w-full"
                value={value}
                color={"primary"}
                maxValue={totalSegments}
                minValue={0}
                step={1}
                showOutline={true}
                size="lg"
                getValue={([from, to]) => <div className={"min-h-8 flex items-center gap-1 text-md text-neutral-400"}>

                    {(isLiveStream && allSegmentsSelected) ? <b>Live Stream</b> :
                        <span>
                            {/*{formatSecondsToHHMMSS(formatValue(from))} ➔ {formatSecondsToHHMMSS(formatValue(to))}*/}
                            <div className={`flex flex-row items-center gap-2 ${isDev ? '' : ''}`}>
                                <DurationInput
                                    ariaLabel={"From"}
                                    value={fromTime}
                                    onChange={(newFromSecs) => {
                                        if (newFromSecs >= toTime) {
                                            return console.log('too big')
                                        }

                                        const newFromValue = getFromValueByFromSecs(newFromSecs);
                                        setValue([newFromValue, value[1]])
                                        setFromTime(newFromSecs)
                                    }}/>
                                ➔
                            <DurationInput
                                ariaLabel={"To"}
                                value={toTime}
                                onChange={(secs) => {
                                const totalSecs = secondsList[secondsList.length - 1];
                                // console.log({secs, totalSecs, secondsList})
                                if (secs > totalSecs) return;

                                if (secs < secondsList[0]) {
                                    setValue([value[0], 1])
                                    setToTime(secs)
                                    return;
                                }

                                let foundSegmentIndex = secondsList.findIndex(secStamp => secStamp > secs)

                                // console.log({foundSegmentIndex});

                                const diff = Math.abs(secondsList[foundSegmentIndex - 1] - secs);
                                // console.log({diff})
                                if (diff > 0.999999) {
                                    foundSegmentIndex = foundSegmentIndex + 1
                                }

                                if (!parsedTimestampsMap[foundSegmentIndex]) {
                                    setValue([value[0], totalSegments])
                                } else {
                                    setValue([value[0], foundSegmentIndex])
                                }
                                setToTime(secs)
                            }}/>
                            </div>

                        </span>}
                    {isLiveStream && !allSegmentsSelected && <>
                        <Tooltip content={<span>
                            Stream length is a bit shorter, due to delays. <br/> Reload the page if it's a problem.
                        </span>} showArrow={true} color={"primary"}>
                            <Button size={"sm"} variant={"light"} isIconOnly>
                                <OutlineInfo width={"20px"} height={"20px"}/>
                            </Button>
                        </Tooltip>
                    </>}
                </div>}
                onChange={(newValue) => {
                    setValue(newValue)
                    setFromTime(secondsToTime(formatValue(newValue[0])))
                    setToTime(secondsToTime(formatValue(newValue[1])))
                }}
                label=" "
                showTooltip={!!thumbnailUrl && !isSmallDevice}
                tooltipProps={{
                    color: 'default',
                    content: <Thumbnail durrationSec={totalDurationSec} thumbnailUrl={thumbnailUrl} fromSecs={fromSecs}
                                        toSecs={toSecs}/>,
                    offset: 5,
                    placement: "top",
                    classNames: {
                        base: ["hidden", "sm:flex"],
                        content: [
                            "bg-transparent",
                    ],
                    },
                }}
            />
            <div className={"flex text-neutral-400 mt-2 flex-col md:flex-row items-center gap-3 md:gap-0"}>

                <div className={"flex sm:justify-between justify-center w-full mt-1"}>
                    <span
                        className={"flex grow-0 gap-1"}>
                {/*<span>Selected duration: </span>*/}
                        {(!allSegmentsSelected || !isLiveStream) &&
                            <span>{formatSecondsToHHMMSS((fromSecs))} ➔ {formatSecondsToHHMMSS((toSecs))}</span>}

                        {/*{(!allSegmentsSelected || !isLiveStream) &&*/}
                        {/*    <span>(total: {formatSecondsToDuration(toSecs - fromSecs) || "0s"})</span>}*/}
                        {allSegmentsSelected ? <span
                            className={"font-bold"}>{video?.type === 'live' ? `Live Stream` : `(entire video)`}</span> : <></>}

                        {
                            !allSegmentsSelected && <Link
                                onPress={() => {
                                    const newValue = [0, totalSegments];
                                    setValue(newValue)
                                    setFromTime(secondsToTime(formatValue(newValue[0])))
                                    setToTime(secondsToTime(formatValue(newValue[1])))
                                }}
                                className={"ml-1 cursor-pointer"}>Reset selection</Link>
                        }
            </span>
                    <span className={"hidden sm:flex grow-0 text-neutral-500"}>Use <Kbd className={"ml-2"}>←</Kbd> <Kbd
                        className={"ml-2 mr-2"}>→</Kbd> keys for more precision</span>
                </div>
            </div>
        </div>
    )
}

function formatSecondsToHHMMSS(totalSeconds: number) {
    const hours = toFixed(Math.floor(totalSeconds / 3600));
    const minutes = String(toFixed(Math.floor((totalSeconds % 3600) / 60))).padStart(2, '0');
    const seconds = String(Math.floor(toFixed(totalSeconds % 60))).padStart(2, '0');
    const millisecondsString = (totalSeconds % 1).toFixed(3).replace('0.', '')

    const milliseconds = +millisecondsString;

    return `${hours ? hours + ":" : ""}${minutes}:${seconds}${milliseconds ? `.${millisecondsString}` : ''}`;
}

function toFixed(value: number) {
    return +value.toFixed(2)
}

function formatSecondsToDuration(totalSeconds) {

    const hours = toFixed(Math.floor(totalSeconds / 3600));
    const minutes = toFixed(Math.floor((totalSeconds % 3600) / 60));
    const seconds = toFixed(Math.round(totalSeconds % 60));
    return `${hours ? hours + "h " : ""}${minutes ? minutes + "m " : ""}${seconds ? (seconds) + "s" : ""}`;
}
